import { createTheme } from '@mui/material/styles';

export const diTheme = createTheme({
  palette: {
    background: { default: '#f8f9fb', paper: '#ffffff' },
    text:       { primary: '#111827', secondary: '#374151', disabled: '#9ca3af' },
    divider:    '#e8eaef',
    primary:    { main: '#111827', contrastText: '#ffffff' },
  },
  typography: { fontFamily: "'Plus Jakarta Sans', sans-serif", fontSize: 14 },
  shape: { borderRadius: 8 },
  components: {
    MuiPaper: {
      defaultProps: { elevation: 0 },
      styleOverrides: { root: { border: '1px solid #e8eaef' } },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 600, fontSize: 13, letterSpacing: '-0.1px', borderRadius: 8,
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 600, fontSize: 13, color: '#9ca3af', minHeight: 44,
          padding: '10px 20px', borderRadius: '8px 8px 0 0',
          '&:hover': { color: '#374151', backgroundColor: '#f3f4f6' },
          '&.Mui-selected': { color: '#111827' },
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: { minHeight: 44 },
        indicator: { backgroundColor: '#111827', height: 2 },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: { borderBottom: '1px solid #e8eaef', fontFamily: "'Plus Jakarta Sans', sans-serif" },
        head: {
          backgroundColor: '#f3f4f6', fontSize: 11, fontWeight: 600,
          textTransform: 'uppercase', letterSpacing: '0.5px', color: '#9ca3af',
          borderBottom: '2px solid #e8eaef', whiteSpace: 'nowrap', padding: '11px 14px',
        },
        body: { padding: '11px 14px', color: '#374151' },
      },
    },
    MuiSelect: {
      styleOverrides: {
        select: {
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontSize: 12, fontWeight: 500, padding: '7px 10px', paddingRight: '28px !important',
        },
      },
    },
  },
});

export const DCOLS = ['#059669','#7c3aed','#d97706','#2563eb','#dc2626','#0891b2','#db2777','#65a30d'];
export const FLDS  = ['module','platform','environment','country'];

export const SEV_STYLE = {
  Critical: { bg: '#fef2f2', color: '#dc2626' },
  High:     { bg: '#fffbeb', color: '#d97706' },
  Medium:   { bg: '#eff6ff', color: '#2563eb' },
  Low:      { bg: '#f3f4f6', color: '#9ca3af' },
};

export const ENV_STYLE = {
  production:  { bg: '#fef2f2', color: '#dc2626' },
  staging:     { bg: '#fffbeb', color: '#d97706' },
  development: { bg: '#eff6ff', color: '#2563eb' },
  pre_prod:    { bg: '#f5f3ff', color: '#7c3aed' },
  beta:        { bg: '#f0fdf4', color: '#16a34a' },
};

export const CONF_COLOR = {
  llm:     '#7c3aed',
  inferred:'#2563eb',
  default: '#059669',
};

export const monoFont = "'JetBrains Mono', monospace";

export const tagSx = (bg, color) => ({
  display: 'inline-flex', alignItems: 'center',
  fontSize: 11, px: '8px', py: '2px', borderRadius: '5px',
  fontFamily: monoFont, fontWeight: 500, whiteSpace: 'nowrap',
  backgroundColor: bg, color,
});

export const selectSx = {
  fontSize: 12, fontWeight: 500, backgroundColor: '#ffffff', borderRadius: '8px', width: '200px',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e8eaef' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#d4d8e2' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#111827', borderWidth: 1 },
};

export function exportTableToCSV(results, dupGroups) {
  const dupMap = {};
  (dupGroups || []).forEach((g, gi) => g.forEach(i => { dupMap[i] = gi + 1; }));
  const headers = ['ID','Summary','Module','Platform','Environment','Country','Severity','Source','Duplicate Group'];
  const rows = results.map((r, i) => [
    r.id, r.summary,
    r.module?.value || '', r.platform?.value || '',
    r.environment?.value || '', r.country?.value || '',
    r.severity || '',
    FLDS.some(f => r[f]?.confidence === 'llm') ? 'AI' : 'KW',
    dupMap[i] ? `Group ${dupMap[i]}` : '',
  ].map(v => `"${String(v).replace(/"/g, '""')}"`).join(','));
  const csv = [headers.join(','), ...rows].join('\n');
  const url = URL.createObjectURL(new Blob([csv], { type: 'text/csv' }));
  Object.assign(document.createElement('a'), { href: url, download: 'defect-intelligence.csv' }).click();
  URL.revokeObjectURL(url);
}